export type Locale = 'en' | 'zh-CN';

export const SUPPORTED_LOCALES: Locale[] = ['en', 'zh-CN'];

export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  'zh-CN': '简体中文',
};

export const DEFAULT_LOCALE: Locale = 'en';
